export default __webpack_public_path__ + "static/media/marker-gray.fb3c003a.png";